import apiClient, { extractData } from "./client";

export async function getPenalties(params = {}) {
  const response = await apiClient.get("/penalties", { params });
  return extractData(response);
}

export async function createPenalty(data) {
  const response = await apiClient.post("/penalties", data);
  return extractData(response);
}

export async function createShortage(data) {
  const response = await apiClient.post("/penalties/shortage", data);
  return extractData(response);
}

export async function approvePenalty(id, data = {}) {
  const response = await apiClient.post(`/penalties/${id}/approve`, data);
  return extractData(response);
}

export async function rejectPenalty(id, data = {}) {
  const response = await apiClient.post(`/penalties/${id}/reject`, data);
  return extractData(response);
}
